import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;

interface Auth0Config {
  domain: string;
  clientId: string;
  audience?: string | null;
}

export function getConfig(): Auth0Config {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN!;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID!;

  const audience =
      process.env.REACT_APP_AUTH0_AUDIENCE &&
      process.env.REACT_APP_AUTH0_AUDIENCE !== "YOUR_API_IDENTIFIER"
          ? process.env.REACT_APP_AUTH0_AUDIENCE
          : null;

  if(!audience){
    console.log (null)
  }
  return {
    domain,
    clientId,
    ...(audience ? { audience } : {}),
  };
}